import React, { ReactElement, ReactNode } from "react";
import classnames from "classnames";

import "./TabSection.scss";

interface TabSectionProps {
  className?: string;
  header: ReactElement | string;
  description?: ReactElement | string;
  children: ReactNode;
}

export const TabSection = ({
  className,
  header,
  description,
  children,
}: TabSectionProps) => {
  return (
    <div className={classnames("tab-section", className)}>
      <div className="tab-section__header">
        <h2 className="tab-section__title">{header}</h2>
        {description && <p>{description}</p>}
      </div>

      <div className="tab-section__content">{children}</div>
    </div>
  );
};
